import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// 1. Import your SchoolProvider (verify this path is correct)
import { SchoolProvider } from './context/SchoolContext'; 
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/routes/ProtectedRoute';

import Welcome from './pages/onboarding/Welcome';
import SectionBuilder from './pages/onboarding/SectionBuilder';
import SetupComplete from './pages/onboarding/SetupComplete';
import Dashboard from './pages/dashboard/Dashboard';
import Settings from './pages/settings/Settings';
import Login from './pages/auth/Login';
import Signup from './pages/auth/Signup';
import AdminGate from './pages/admin/AdminGate';

function App() {
  return (
    <BrowserRouter>
      {/* 2. Wrap your Routes with the Provider */}
      <ThemeProvider>
        <AuthProvider>
          <SchoolProvider>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/welcome" element={<Welcome />} />
              <Route path="/admin-mos3c" element={<AdminGate />} />
              <Route path="/onboarding/sections" element={<ProtectedRoute><SectionBuilder /></ProtectedRoute>} />
              <Route path="/onboarding/complete" element={<ProtectedRoute><SetupComplete /></ProtectedRoute>} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            </Routes>
          </SchoolProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
